import { useEffect, useState } from 'react'

// Debounce function
function debounce(func, wait, immediate) {
  let timeout
  return function (...args) {
    const later = function () {
      timeout = null
      // @ts-ignore
      if (!immediate) func.apply(this, ...args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    // @ts-ignore
    if (callNow) func.apply(this, ...args)
  }
}

// https://gist.github.com/didacus/ae19f2e3fb6c5f0de61e3dc7314ad24f
export function useWindowSize() {
  function getSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }

  const [windowSize, setWindowSize] = useState(getSize)

  useEffect(() => {
    // Debounce to avoid the function fire multiple times
    const handleResizeDebounced = debounce(
      () => {
        setWindowSize(getSize())
      },
      100,
      false
    )

    window.addEventListener('resize', handleResizeDebounced)
    return () => window.removeEventListener('resize', handleResizeDebounced)
  }, [])

  return windowSize
}
